import { AxiosInstance } from 'axios';
import { PhotoRetailPriceRepository } from '@/model/repository/manager/parentSales/PhotoRetailPriceRepository';
import axios from 'axios';

export default (Repository: AxiosInstance | null) =>
  (resource: string): PhotoRetailPriceRepository => ({
    get() {
      const axiosInstance = Repository ?? axios.create({ withCredentials: true });
      return axiosInstance.get(`${resource}`);
    },
  });
